import React from 'react';

/**
 * Componente que imprime a string da fórmula nos modais de operaçõe.
 */
const FormulaPreview = ({ formula }) => {
  return (
    <pre style={{ borderRadius: '4px', border: '1px solid #DEE6E9', display: 'flex', padding: '10px 12px', alignItems: 'center', gap: '8px', alignSelf: 'stretch' }}>
      {formula || '—'}
    </pre>
  );
};

export default FormulaPreview; 